import $ from 'jquery';

/**
 * Create sharing popovers to product search list
 * Uses Bootstrap 4 popover functionality
 * @param {object} container jquery object
 */
function createProductListPopovers(container) {

  const popButtons = container.find('.popover--product-list');

  //add popover functionality
  popButtons.popover()
    .on('show.bs.popover', function () {
    //when popover is launched, make parent element stay in hover state
      $(this).parents('.card--product').addClass('active');
    }).on('hidden.bs.popover', function () {
    //remove hover state
      $(this).parents('.card--product').removeClass('active');
    });

  //prevent opening the product page
  popButtons.click((e) => {
    e.preventDefault();
  });
}

function init () {
  $('.popover--default').popover({
    container: 'body'
  });

  if($('.product-finder__search-results').length) {
    createProductListPopovers($('.product-finder__search-results'));
  }

}

export default { init, createProductListPopovers };
export { init, createProductListPopovers };
